import React, { useState } from "react";
import { PhoneIcon } from "@heroicons/react/solid";
import MainIntersectProvider from "./../../MainIntersectProvider";

export default function Contact() {
	const [data, setData] = useState({
		name: "",
		email: "",
		message: "",
	});
	const [isSubmitted, setSubmitted] = useState(false);
	const [isLoading, setLoading] = useState(false);

	const handleChange = (e) => {
		const name = e.target.name;
		setData((prevState) => ({
			...prevState,
			[name]: e.target.value,
		}));
	};

	async function postData() {
		setLoading(true);
		try {
			const response = await fetch("https://nodegmailserver.herokuapp.com/", {
				method: "POST",
				headers: {
					Accept: "application/json",
					"Content-Type": "application/json",
				},
				body: JSON.stringify({ ...data }),
			});
			const responseJson = await response.json();
			console.log(responseJson);
			setLoading(false);
			return responseJson;
		} catch (error) {
			setLoading(false);
			console.error(error);
			return "Error generated!😠";
		}
	}

	const handleSubmit = async (e) => {
		e.preventDefault();
		const poster = await postData();
		console.log(poster);
		if (poster && poster.status === "success") {
			setSubmitted(true);
		}
	};

	return (
		<section id='contact' className='relative'>
			<div className='container px-5 xl:px-40 pt-20 mx-auto flex flex-wrap'>
				<div className='text-center'>
					<MainIntersectProvider>
						<PhoneIcon className='w-10 inline-block mb-4' />
					</MainIntersectProvider>
					<h2 className='sm:text-3xl text-2xl font-medium title-font text-white mb-4'>
						Contact Me
					</h2>
					<p className='text-base leading-relaxed text-center'>
						Currently looking for new and decent opportunities. Whether you have
						a question or just want to say hello, feel free to drop me a text.
						I'll try my best to get back to you!
					</p>
				</div>
				{!isSubmitted ? (
					<form
						method='POST'
						onSubmit={handleSubmit}
						className='flex flex-col md:ml-auto w-full pb-8 md:py-8 mt-8 md:mt-0'
					>
						<div className='relative mb-4'>
							<label className='leading-8 text-sm text-gray-400'>Name</label>
							<input
								onChange={handleChange}
								required
								placeholder='Enter Name'
								type='text'
								name='name'
								className='w-full bg-gray-800 border border-gray-700 focus:border-yellow-500 rounded-md text-base outline-none text-gray-100 py-1 px-3 leading-8 transition-colors duration-200 ease-in-out'
							/>
						</div>
						<div className='relative mb-4'>
							<label className='leading-8 text-sm text-gray-400'>Email</label>
							<input
								onChange={handleChange}
								required
								placeholder='Enter Email'
								type='email'
								name='email'
								className='w-full bg-gray-800 border border-gray-700 focus:border-yellow-500 rounded-md text-base outline-none text-gray-100 py-1 px-3 leading-8 transition-colors duration-200 ease-in-out'
							/>
						</div>
						<div className='relative mb-4'>
							<label className='leading-8 text-sm text-gray-400'>Message</label>
							<textarea
								onChange={handleChange}
								required
								placeholder='Drop a message here...'
								name='message'
								className='w-full bg-gray-800 border border-gray-700 focus:border-yellow-500 rounded-md h-32 text-base outline-none text-gray-100 py-1 px-3 resize-none leading-6 transition-colors duration-200 ease-in-out'
							/>
						</div>
						<div className='w-full flex justify-center pt-5'>
							<button
								type='submit'
								disabled={isLoading}
								className='rounded-md w-full md:w-1/6 bg-gradient-to-r from-pink-500 to-yellow-500 text-white bg-green-500 border-0 py-2 px-6 focus:outline-none hover:bg-green-600 text-md'
							>
								{isLoading ? "Loading..." : "Submit"}
							</button>
						</div>
					</form>
				) : (
					<div
						className='mt-10 mb-20 w-full bg-yellow-100 rounded-md border-t-8 border-yellow-600 p-4'
						role='alert'
					>
						<p className='text-black font-bold'>Success</p>
						<p className='text-black'>
							Form has been successfully submitted. Thank you 🙏🏻
						</p>
					</div>
				)}
			</div>
		</section>
	);
}
